/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./AccountDetalizationContainer.less";
import { useRouteMatch } from "react-router-dom";
import { Form, message, Modal } from "antd";
import isEmpty from "lodash/isEmpty";
import omit from "lodash/omit";
import isEqual from "lodash/isEqual";
import axios from "axios";
import {
  fetchRejectedTrafficDetailSearch,
  resetRejectedTrafficDetailSearch,
} from "../../store/slices/rejected-traffic";
import { toHttpFormatEndOfDay, toHttpFormatStartOfDay } from "../../lib/utils/formatDate";
import {
  fetchServiceUsageDocumentType,
  fetchTrafficStatus,
} from "../../store/slices/rtkDictionaries";
import AccountDetalization from "../../components/AccountDetalization/AccountDetalization";
import { AccountDetalizationContainerContext } from "./AccountDetalizationContainerContext";
import { reprocessPrebillingRoute } from "../../lib/routes/pre-processor";
import { fetchServiceUsageProcessingType } from "../../store/slices/dicts";

const AccountDetalizationContainer = () => {
  const {
    fetchRejectedTrafficDetailSearchContent,
    fetchRejectedTrafficDetailSearchContentLoading,
  } = useSelector((state) => state.rejected);
  const dispatch = useDispatch();
  const { url } = useRouteMatch();
  const [form] = Form.useForm();
  const accoundId = url.split("/")[2];

  const initialFormSearchValues = {
    onlyFailServiceUsageStatusIds: false,
    includeServiceUsageStatusIds: [],
    includeDocumentIds: "",
    rangeDate: "",
    includeProcessingTypes: [],
  };

  const [disabledFields, setDisabledFields] = useState({});
  const [pagination, setPagination] = useState({ page: 0, size: 20 });
  const [runReprocessLoading, setRunReprocessLoading] = useState(false);

  const handleSetPagination = (prop) => {
    setPagination((prev) => ({
      ...prev,
      ...prop,
    }));
  };

  const getSearchValues = () => {
    const { size, page } = pagination;
    const formValues = form.getFieldsValue();
    const preparedFormValues = formValues.onlyFailServiceUsageStatusIds
      ? omit(formValues, "rangeDate", "includeServiceUsageStatusIds")
      : omit(formValues, "rangeDate", "onlyFailServiceUsageStatusIds");
    return {
      ...preparedFormValues,
      fromDate: formValues.rangeDate[0] ? toHttpFormatStartOfDay(formValues.rangeDate[0]) : "",
      toDate: formValues.rangeDate[1] ? toHttpFormatEndOfDay(formValues.rangeDate[1]) : "",
      subscribersThroughSubscriberIds: accoundId,
      size,
      page,
    };
  };

  const handleSearchRejectsTraffic = () => {
    dispatch(fetchRejectedTrafficDetailSearch({ ...getSearchValues(), page: 0 }));
  };

  useEffect(() => {
    const isSearchValuesChanged = !isEqual(form.getFieldsValue(), initialFormSearchValues);
    // Проверка для отключения дефолтной загрузки
    if (isSearchValuesChanged) {
      dispatch(
        fetchRejectedTrafficDetailSearch({ ...getSearchValues(), page: pagination.page - 1 })
      );
    }
  }, [pagination]);

  // Очистка результатов поиска по выходу
  useEffect(() => () => dispatch(resetRejectedTrafficDetailSearch()), []);

  useEffect(() => {
    dispatch(fetchTrafficStatus());
    dispatch(fetchServiceUsageProcessingType());
    dispatch(fetchServiceUsageDocumentType());
  }, []);

  const onChecked = (isChecked) => {
    setDisabledFields((prev) => ({ ...prev, includeServiceUsageStatusIds: isChecked }));
    form.setFieldsValue({ onlyFailServiceUsageStatusIds: isChecked });
  };

  const onSelect = (values) => {
    if (isEmpty(values)) {
      setDisabledFields((prev) => ({ ...prev, onlyFailServiceUsageStatusIds: false }));
    } else {
      setDisabledFields((prev) => ({ ...prev, onlyFailServiceUsageStatusIds: true }));
    }
  };

  const runReprocess = ({ fromDate, toDate, subscribers }) => {
    message.loading("Формирование задания...", 0);
    setRunReprocessLoading(true);
    axios
      .post(reprocessPrebillingRoute(), {
        fromDate,
        toDate,
        subscribers,
        deleteEmptyAggUsageType: "bySubscribers",
        deleteEmptyAggUsageSubscribers: subscribers,
      })
      .then((res) => {
        if (res.status === 200) {
          message.destroy();
          message.success("Задание сформировано");
        }
        setRunReprocessLoading(false);
      })
      .catch(() => {
        message.destroy();
        Modal.error({
          title: "Ошибка формирования",
          content: "",
        });
        setRunReprocessLoading(false);
      });
  };

  const resetSearchRejectsTraffic = () => {
    form.resetFields();
    setPagination({ page: 0, size: 20 });
    dispatch(resetRejectedTrafficDetailSearch());
  };

  return (
    <AccountDetalizationContainerContext.Provider
      value={{
        runReprocess,
      }}
    >
      <AccountDetalization
        disabledFields={disabledFields}
        pagination={pagination}
        initialFormSearchValues={initialFormSearchValues}
        getSearchValues={getSearchValues}
        handleSearchRejectsTraffic={handleSearchRejectsTraffic}
        resetSearchRejectsTraffic={resetSearchRejectsTraffic}
        onChecked={onChecked}
        onSelect={onSelect}
        handleSetPagination={handleSetPagination}
        form={form}
        fetchRejectedTrafficDetailSearchContentLoading={
          fetchRejectedTrafficDetailSearchContentLoading
        }
        fetchRejectedTrafficDetailSearchContent={fetchRejectedTrafficDetailSearchContent}
        runReprocessLoading={runReprocessLoading}
      />
    </AccountDetalizationContainerContext.Provider>
  );
};
export default AccountDetalizationContainer;
